import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { SuccessButton } from '../Buttons'
import { Patient } from '../Pacients/PacientCard'

function StandardTextField(props: TextFieldProps) {
  return <TextField {...props} label="CPF" fullWidth variant="standard" />
}

interface PacientDialogProps {
  open: boolean
  handleChange: (pacient: Patient) => void
  handleClose: () => void
  patient?: Patient
}

interface IFormInput {
  name: string
  cpf: string
  phone: string
  email: string
  annotations: string
}

export const PacientDialog = ({
  handleChange,
  handleClose,
  patient,
  open
}: PacientDialogProps): JSX.Element => {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<IFormInput>({
    mode: 'onChange',
    shouldUnregister: true,
    shouldFocusError: true
  })
  const onSubmit = (data: IFormInput) => {
    handleChange(data)
    handleClose()
  }

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        fullWidth
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Paciente</DialogTitle>
          <DialogContent>
            <DialogContentText>Cadastre um novo.</DialogContentText>
            <Controller
              name="name"
              control={control}
              defaultValue={patient?.name}
              rules={{
                required: 'Este campo é obrigatório'
              }}
              render={({ onChange, value }) => (
                <TextField
                  label="Paciente"
                  autoFocus
                  fullWidth
                  value={value}
                  onChange={onChange}
                  margin="dense"
                  error={!!errors.name?.message}
                  helperText={errors.name?.message}
                />
              )}
            />
            <br />
            <Controller
              name="cpf"
              control={control}
              defaultValue={patient?.cpf}
              rules={{
                required: 'Este campo é obrigatório'
              }}
              render={({ onChange, value }) => (
                <NumberFormat
                  style={{ width: '100%' }}
                  format="###.###.###-##"
                  value={value}
                  onChange={onChange}
                  customInput={StandardTextField}
                />
              )}
            />
            <Controller
              name="phone"
              control={control}
              rules={{
                maxLength: {
                  message: 'O telefone deve ter no máximo 15 caracteres',
                  value: 15
                }
              }}
              defaultValue={patient?.phone}
              render={({ onChange, value }) => (
                <TextField
                  label="Telefone"
                  fullWidth
                  value={value}
                  onChange={onChange}
                  margin="dense"
                  helperText={errors.phone?.message}
                  error={!!errors.phone?.message}
                />
              )}
            />
            <Controller
              name="email"
              control={control}
              rules={{
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Formato incorreto'
                }
              }}
              defaultValue={patient?.email || ''}
              render={({ onChange, value }) => (
                <TextField
                  label="Email"
                  fullWidth
                  value={value}
                  onChange={onChange}
                  type="email"
                  margin="dense"
                  helperText={errors.email?.message}
                  error={!!errors.email?.message}
                />
              )}
            />
            <Controller
              name="annotations"
              control={control}
              defaultValue={patient?.annotations}
              render={({ onChange, value }) => (
                <TextField
                  label="Observação"
                  fullWidth
                  value={value}
                  multiline
                  rows={4}
                  onChange={onChange}
                  margin="dense"
                  helperText={errors.annotations?.message}
                  error={!!errors.annotations?.message}
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <SuccessButton type="submit" color="primary">
              Salvar
            </SuccessButton>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
